import {Router} from '@angular/router';
import {OrganisationService} from 'app/blocks/service/api/organisation.service';
import {Organisation} from 'app/blocks/model/organisation.model';
import {Resource} from 'app/constants/resource';
import {Injectable} from '@angular/core';
import {IOrganisation} from 'app/blocks/model/organisation.model';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {EntityUrlProvider} from 'app/blocks/routing/entity-url-provider';
import {ENTITIES_SETUP_BASE_URL} from 'app/app.constants';

@Injectable({
    providedIn: 'root'
})
export class OrganisationResource extends AbstractEntityResource<IOrganisation> {
    constructor(organisationService: OrganisationService, router: Router) {
        super(
            Resource.ORGANISATIONS,
            organisationService,
            new EntityNavigator(ENTITIES_SETUP_BASE_URL, Resource.ORGANISATIONS, router),
            new EntityUrlProvider(ENTITIES_SETUP_BASE_URL, Resource.ORGANISATIONS),
            (entity?) => new Organisation(entity),
            (entity) => entity.name
        );
    }
}
